import React, { Component } from "react";
import Global from "../../Global";
import "./PopUpBanner.css";

export default class PopUpBanner extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isVisible: true,
      isMobileImg: false,
      homePopUpBannerData: null,
      isImgLoaded:false,
    };

    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleOnLoadImg = this.handleOnLoadImg.bind(this);
    this.handleOnClick = this.handleOnClick.bind(this);
  }

  componentWillMount() {
    // FETCH JSON
    var url = Global.getAPI("home-popup-banner");
    var self = this;
    fetch(url)
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Error API: home-popup-banner");
        }
        return response.json();
      })
      .then(function(data) {
        self.setState({
          homePopUpBannerData: data,
        });
      });
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
  }

  resize() {
    let currentIsMobileImg = window.innerWidth <= 767;
    if (currentIsMobileImg == this.state.isMobileImg) return;

    this.setState({ isMobileImg: currentIsMobileImg });
  }

  handleDismiss() {
    this.setState({ isVisible: false });
  }

  handleOnLoadImg() {
    this.setState({ isImgLoaded: true });
  }
  
  handleOnClick() {
    const { homePopUpBannerData} = this.state;
    this.copyToClipboard(homePopUpBannerData.homePopUpBanner.promoCode);
  }

  copyToClipboard(text) {
      const elem = document.createElement('textarea');
      elem.value = text;
      document.body.appendChild(elem);
      elem.select();
      document.execCommand('copy');
      document.body.removeChild(elem);
  }

  render() {
    const { homePopUpBannerData, isMobileImg, isVisible,isImgLoaded } = this.state;
      
    if (homePopUpBannerData == null || !homePopUpBannerData.isOn || !homePopUpBannerData.isShownOnThreeCom || homePopUpBannerData.homePopUpBanner == null || !isVisible) return null;

    const imagePath = isMobileImg
      ? homePopUpBannerData.homePopUpBanner.imageMobile
      : homePopUpBannerData.homePopUpBanner.imageDesktop;

    return (
      <div className="popUpBannerContainer" style={{display:isImgLoaded ? "flex" : "none" }}>
        <button role="button" className="btnDismiss" onClick={this.handleDismiss}>&#10006;</button>
        <div class="bannerImageContainer" onClick={this.handleOnClick}>
          <a
            href={homePopUpBannerData.homePopUpBanner.url}
            target={
              homePopUpBannerData.homePopUpBanner.isOpenInNewWindow
                ? "_blank"
                : "_self"
            }
          >
            <img
              class="banner-img"
              role="button"
              onLoad={this.handleOnLoadImg}
              alt={homePopUpBannerData.homePopUpBanner.alt}
              src={imagePath}
            />
          </a>
        </div>
      </div>
    );
  }
}
